<template>
  <div>
    <div class="officers-details mb-4" v-if="officerDetails.length">
      <table style="width: 100%">
        <tbody>
          <tr class="sticky-item">
            <td class="officer-header">Details of Officers</td>
            <td class="sub-header">Crew Name</td>
            <td class="sub-header">Nationality</td>
            <td class="sub-header">Certificate of Competency</td>
            <td class="sub-header">Issuing Country</td>
            <td class="sub-header">Administration Acceptance</td>
            <td class="sub-header">Experience in this type of Vessel</td>
            <td class="sub-header">Over all Experience</td>
            <td class="sub-header">English Knowledge</td>
            <td class="sub-header">Year in rank</td>
            <td class="sub-header">Tanker Cert</td>
            <td class="sub-header">Years with Operator</td>
            <td class="sub-header">STCW V para</td>
          </tr>
          <tr
            class="details-row"
            v-for="(tr, trindex) in officerDetails"
            :key="trindex"
          >
            <td class="officer-header">{{ tr.qualification_role.name }}</td>
            <td
              contenteditable="true"
              @blur="(event) => checkList(event, tr, 'crew_name')"
              onkeypress="return event.keyCode != 13;"
              v-html="tr.crew_name"
            >
              {{ tr.crew_name }}
            </td>
            <td
              contenteditable
              @blur="(event) => checkList(event, tr, 'nationality')"
              onkeypress="return event.keyCode != 13;"
              v-html="tr.nationality"
            >
              {{ tr.nationality }}
            </td>
            <td
              contenteditable
              @blur="
                (event) => checkList(event, tr, 'certificate_of_competency')
              "
              onkeypress="return event.keyCode != 13;"
              v-html="tr.certificate_of_competency"
            >
              {{ tr.certificate_of_competency }}
            </td>
            <td
              contenteditable
              @blur="(event) => checkList(event, tr, 'issuing_country')"
              onkeypress="return event.keyCode != 13;"
              v-html="tr.issuing_country"
            >
              {{ tr.issuing_country }}
            </td>
            <td
              contenteditable
              @blur="
                (event) => checkList(event, tr, 'administration_acceptance')
              "
              onkeypress="return event.keyCode != 13;"
              v-html="tr.administration_acceptance"
            >
              {{ tr.administration_acceptance }}
            </td>
            <td
              contenteditable
              @blur="
                (event) => checkList(event, tr, 'experience_of_this_vessel')
              "
              onkeypress="return event.keyCode != 13;"
              v-html="tr.experience_of_this_vessel"
            >
              {{ tr.experience_of_this_vessel }}
            </td>
            <td
              contenteditable
              @blur="(event) => checkList(event, tr, 'overall_experience')"
              onkeypress="return event.keyCode != 13;"
              v-html="tr.overall_experience"
            >
              {{ tr.overall_experience }}
            </td>
            <td
              contenteditable
              @blur="(event) => checkList(event, tr, 'english_knowledge')"
              onkeypress="return event.keyCode != 13;"
              v-html="tr.english_knowledge"
            >
              {{ tr.english_knowledge }}
            </td>
            <td
              contenteditable
              @blur="(event) => checkList(event, tr, 'years_in_rank')"
              onkeypress="return event.keyCode != 13;"
              v-html="tr.years_in_rank"
            >
              {{ tr.years_in_rank }}
            </td>
            <td
              contenteditable
              @blur="(event) => checkList(event, tr, 'tanker_certificate')"
              onkeypress="return event.keyCode != 13;"
              v-html="tr.tanker_certificate"
            >
              {{ tr.tanker_certificate }}
            </td>
            <td
              contenteditable
              @blur="(event) => checkList(event, tr, 'years_with_operator')"
              onkeypress="return event.keyCode != 13;"
              v-html="tr.years_with_operator"
            >
              {{ tr.years_with_operator }}
            </td>
            <td
              contenteditable
              @blur="(event) => checkList(event, tr, 'stcw_level')"
              onkeypress="return event.keyCode != 13;"
              v-html="tr.stcw_level"
            >
              {{ tr.stcw_level }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="officers-details mb-4" v-if="engineerDetails.length">
      <table style="width: 100%">
        <tbody>
          <tr class="sticky-item">
            <td class="officer-header">Details of Engineers</td>
            <td class="sub-header">Crew Name</td>
            <td class="sub-header">Nationality</td>
            <td class="sub-header">Certificate of Competency</td>
            <td class="sub-header">Issuing Country</td>
            <td class="sub-header">Administration Acceptance</td>
            <td class="sub-header">Experience in this type of Vessel</td>
            <td class="sub-header">Over all Experience</td>
            <td class="sub-header">English Knowledge</td>
            <td class="sub-header">Year in rank</td>
            <td class="sub-header">Tanker Cert</td>
            <td class="sub-header">Years with Operator</td>
            <td class="sub-header">STCW V para</td>
          </tr>
          <tr
            class="details-row"
            v-for="(tr, trindex) in engineerDetails"
            :key="trindex"
          >
            <td class="officer-header">{{ tr.qualification_role.name }}</td>
            <td
              contenteditable
              onkeypress="return event.keyCode != 13;"
              @blur="(event) => checkListEngineer(event, tr, 'crew_name')"
              v-html="tr.crew_name"
            >
              {{ tr.crew_name }}
            </td>
            <td
              contenteditable
              onkeypress="return event.keyCode != 13;"
              @blur="(event) => checkListEngineer(event, tr, 'nationality')"
              v-html="tr.nationality"
            >
              {{ tr.nationality }}
            </td>
            <td
              contenteditable
              onkeypress="return event.keyCode != 13;"
              @blur="
                (event) =>
                  checkListEngineer(event, tr, 'certificate_of_competency')
              "
              v-html="tr.certificate_of_competency"
            >
              {{ tr.certificate_of_competency }}
            </td>
            <td
              contenteditable
              onkeypress="return event.keyCode != 13;"
              @blur="(event) => checkListEngineer(event, tr, 'issuing_country')"
              v-html="tr.issuing_country"
            >
              {{ tr.issuing_country }}
            </td>
            <td
              contenteditable
              onkeypress="return event.keyCode != 13;"
              @blur="
                (event) =>
                  checkListEngineer(event, tr, 'administration_acceptance')
              "
              v-html="tr.administration_acceptance"
            >
              {{ tr.administration_acceptance }}
            </td>
            <td
              contenteditable
              onkeypress="return event.keyCode != 13;"
              @blur="
                (event) =>
                  checkListEngineer(event, tr, 'experience_of_this_vessel')
              "
              v-html="tr.experience_of_this_vessel"
            >
              {{ tr.experience_of_this_vessel }}
            </td>
            <td
              contenteditable
              onkeypress="return event.keyCode != 13;"
              @blur="
                (event) => checkListEngineer(event, tr, 'overall_experience')
              "
              v-html="tr.overall_experience"
            >
              {{ tr.overall_experience }}
            </td>
            <td
              contenteditable
              onkeypress="return event.keyCode != 13;"
              @blur="
                (event) => checkListEngineer(event, tr, 'english_knowledge')
              "
              v-html="tr.english_knowledge"
            >
              {{ tr.english_knowledge }}
            </td>
            <td
              contenteditable
              onkeypress="return event.keyCode != 13;"
              @blur="(event) => checkListEngineer(event, tr, 'years_in_rank')"
              v-html="tr.years_in_rank"
            >
              {{ tr.years_in_rank }}
            </td>
            <td
              contenteditable
              onkeypress="return event.keyCode != 13;"
              @blur="
                (event) => checkListEngineer(event, tr, 'tanker_certificate')
              "
              v-html="tr.tanker_certificate"
            >
              {{ tr.tanker_certificate }}
            </td>
            <td
              contenteditable
              onkeypress="return event.keyCode != 13;"
              @blur="
                (event) => checkListEngineer(event, tr, 'years_with_operator')
              "
              v-html="tr.years_with_operator"
            >
              {{ tr.years_with_operator }}
            </td>
            <td
              contenteditable
              onkeypress="return event.keyCode != 13;"
              @blur="(event) => checkListEngineer(event, tr, 'stcw_level')"
              v-html="tr.stcw_level"
            >
              {{ tr.stcw_level }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mt-4 text-right">
      <vs-button
        class="vs-component vs-button vs-button-warning vs-button-filled"
        color="warning"
        :disabled="button_loading"
        button="submit"
        @click="saveData()"
        >{{ $t("labels.save_data") }}</vs-button
      >
    </div>
  </div>
</template>
<style scoped></style>
<script>
export default {
  components: {},
  data() {
    return {
      officerDetails: [],
      engineerDetails: [],
      totalPage: 1,
      currentx: 1,
      limit: parseInt(process.env.VUE_APP_PER_PAGE),
      showfilter: false,
      search: null,
      service: 0,
      services_drop: [],
    };
  },
  props: ["consultantId", "serviceId"],
  computed: {},
  mounted() {
    this.getOfficersData();
  },
  methods: {
    async getOfficersData() {
      let input = {
        consultant_id: this.consultantId,
        service_id: this.serviceId,
      };
      let response = await this.getHTTPPostResponse(
        "qualification-details/list/" + this.$route.params.id,
        input
      );
      if (response) {
        let data = response.data;
        let officers = data.qualification_officer;
        let engineers = data.qualification_engineer;
        this.engineerDetails = engineers;
        this.officerDetails = officers;
      }
    },
    async saveData() {
      let input = {
        qualification_officer: this.officerDetails,
        qualification_engineer: this.engineerDetails,
      };
      await this.getHTTPPostResponse(
        "qualification-details/store",
        input,
        "",
        true
      );
    },
    async checkList(event, item, type) {
      var $row = $(item).parents("tr"); //accede a la fila
      var $cols = $row.find("td");

      this.officerDetails.forEach((el) => {
        if (el.id === item.id) {
          el[type] = event.target.innerText;
        }
      });
      this.officerDetails = this.officerDetails;
    },
    async checkListEngineer(event, item, type) {
      var $row = $(item).parents("tr"); //accede a la fila
      var $cols = $row.find("td");

      this.engineerDetails.forEach((el) => {
        if (el.id === item.id) {
          el[type] = event.target.innerText;
        }
      });
      this.engineerDetails = this.engineerDetails;
    },
  },
};
</script>
<style scoped>
table {
  display: table;
  border: none !important;
  border-collapse: collapse;
}
table tr {
  display: table-cell;
  border: none !important;
}
table tr td {
  padding: 15px 15px !important;
  border-bottom: 2px solid #f6f6f6;
  border-right: 2px solid #f6f6f6 !important;
  display: block;
}
.officer-header {
  background: rgba(var(--vs-dark), 1) !important;
  color: #fff;
  font-weight: 600;
  border: none !important;
}
.details-row,
.details-row td {
  width: 300px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}
.sticky-item td {
  border-left: 2px solid #f6f6f6;
  width: 329px;
}
td {
  height: 52px;
  max-height: 52px;
}
.sub-header {
  background: #ffffff;
}
</style>
